import * as Yup from 'yup'
import { Constant } from '@utils'
export const imageInputSchema = Yup.lazy((value) => {
  if (typeof value === 'string') {
    // Existing images are referenced by their stored path, which the
    // backend owns (bucket/folder naming can vary by environment) — just
    // confirm it's a non-empty reference rather than pattern-matching a
    // specific prefix.
    return Yup.string().min(1, 'Invalid image').required('Invalid image')
  }

  return Yup.object().shape({
    base64: Yup.string().required('Image is required'),
    extension: Yup.string()
      .oneOf(
        Constant.imageValidationExtensions,
        `Extension must be one of: ${Constant.imageValidationExtensions.join(', ')}`,
      )
      .required('Invalid Extension'),
  })
})

export const imageNullInputSchema = Yup.lazy((value) => {
  if (typeof value === 'string') {
    return Yup.string().min(1, 'Invalid image').nullable(true).notRequired()
  }

  return Yup.object()
    .nullable(true)
    .shape({
      base64: Yup.string().notRequired(),
      extension: Yup.string()
        .oneOf(
          Constant.imageValidationExtensions,
          `Extension must be one of: ${Constant.imageValidationExtensions.join(', ')}`,
        )
        .notRequired(),
    })
})
